import * as React from "react"
import { observer } from "mobx-react-lite"
import { Text } from "../text/text"
import { View } from "native-base"
import { Appearance, StyleProp } from "react-native"
import { Image } from "../image/image"
import { ImageStyle, Source } from "react-native-fast-image"
import { IViewProps } from "native-base/lib/typescript/components/primitives/View"
import { translate } from "../../i18n"
import { Button } from "../button/button"
import { color } from "../../theme"

const listNetworkError = require('./list-network-error.png')

export interface ListNetworkErrorProps extends IViewProps {
  colorScheme?: "light"|"dark",
  source?: number | Source,
  text?: string,

  imageStyles?: any,

  onRefresh?: () => void
}

const IMAGE: StyleProp<ImageStyle> = {
  width: 117,
  height: 117
}

const REFRESH_BUTTON = {
  marginTop: 16,
  marginBottom: 12,
  width: 164
}

/**
 * Describe your component here
 */
export const ListNetworkError = observer(function ListNetworkError(props: ListNetworkErrorProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    source = listNetworkError,
    text = translate("homeScreen.noConnection"),
    onRefresh,
    imageStyles = IMAGE,
    ...restProps
  } = props;

  return (
    <View flexGrow={1} alignItems="center" justifyContent="center" {...restProps}>
      <View marginBottom="12px" paddingX="8px" alignItems="center">
        <View marginBottom="8px" alignItems="center" justifyContent="center">
          <Image source={source} style={imageStyles} />
        </View>
        {text && <Text text={text} preset="body3" textAlign="center" color={color.palette.gray700} colorScheme={colorScheme} />}
      </View>
      {!!onRefresh && <Button
        testID="jala:id/button"
        tx="listNetworkError.refreshPage"
        preset="primary"
        colorScheme={colorScheme}
        onPress={onRefresh}
        style={REFRESH_BUTTON}
      />}
    </View>
  )
})
